export default __webpack_public_path__ + "static/media/Thanachart.4dbf1d77.png";